import { API_ENDPOINTS } from '@/constants';
import type { ApiBuilder } from './types';
import type {
  MetricsOutputDTO,
  GetOccupancyMetricsParams,
  GetServiceLevelMetricsParams,
  GetAgentQueueStatusParams,
  GetAgentQueueStatusOutputDTO,
} from '@/types/agentEvents';

const metricsQuery =
  (url: string) =>
  (params: Record<string, unknown> = {}) => ({
    url,
    params,
  });

export const managerEventsApi = (builder: ApiBuilder) => ({
  getOccupancyMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.OCCUPANCY
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAdherenceMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.ADHERENCE
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getContactsHandledMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.CONTACTS_HANDLED
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAbandonmentRateMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.ABANDONMENT_RATE
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAverageHandleTimeMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.AVERAGE_HANDLE_TIME
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAverageWrapTimeMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.AVERAGE_WRAP_TIME
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAverageHoldTimeMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.AVERAGE_HOLD_TIME
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAverageQueueAnswerTimeMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.AVERAGE_QUEUE_ANSWER_TIME
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getServiceLevelMetrics: builder.query<
    MetricsOutputDTO,
    GetServiceLevelMetricsParams | void
  >({
    query: params =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.SERVICE_LEVEL
      )((params ?? {}) as unknown as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getDeflectionRateMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.DEFLECTION_RATE
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getFirstContactResolutionMetrics: builder.query<
    MetricsOutputDTO,
    GetOccupancyMetricsParams | void
  >({
    query: (params = {}) =>
      metricsQuery(
        API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.FIRST_CONTACT_RESOLUTION
      )(params as Record<string, unknown>),
    providesTags: ['AgentEvents'],
  }),

  getAgentQueueStatus: builder.query<
    GetAgentQueueStatusOutputDTO,
    GetAgentQueueStatusParams
  >({
    query: ({ agentIds }: { agentIds: string }) => {
      const queryParams: Record<string, unknown> = {};

      if (agentIds) {
        queryParams.agentIds = agentIds;
      }

      return {
        url:
          API_ENDPOINTS.AGENT_EVENTS.BASE_URL_MANAGER +
          API_ENDPOINTS.AGENT_EVENTS.QUEUE_STATUS,
        params: Object.keys(queryParams).length > 0 ? queryParams : {},
      };
    },
    providesTags: ['AgentEvents'],
  }),
});
